define(["require", "exports", "./modules/utils/printHelper"], function (require, exports, printHelper_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var printButton = document.querySelector('.print-button');
    var pageBody = document.querySelector('#page-body');
    var printTerm = function () {
        var _a;
        (_a = pageBody === null || pageBody === void 0 ? void 0 : pageBody.querySelector('span[local-date="true"]')) === null || _a === void 0 ? void 0 : _a.removeAttribute("local-date");
        var htmlContent = '<div class="print:flex print:w-full print:visible print:flex-col print:items-center print:justify-center print:print-cofiguration print:overflow-visible print:absolute print:left-0 hidden">';
        htmlContent += "<div class=\"print:w-full print:border-none print:visible print:flex print:flex-col print:my-10\">" + (pageBody === null || pageBody === void 0 ? void 0 : pageBody.innerHTML) + "</div>";
        htmlContent += '</div>';
        printHelper_1.PrintHelper.printContent(htmlContent);
    };
    window.addEventListener('load', function () {
        printButton === null || printButton === void 0 ? void 0 : printButton.addEventListener('click', printTerm);
    });
});
